import script from "./TaskList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskList.vue?vue&type=script&lang=ts&setup=true"

import "./TaskList.vue?vue&type=style&index=0&id=919eb988&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-919eb988"]])

export default __exports__